import i18n from '@/locales'
export const BAND_WIDTH_OPTION = [
  { label: i18n.t('network.text_1'), value: '100' },
  { label: i18n.t('network.text_2'), value: '1000' },
  { label: i18n.t('network.text_3'), value: '2000' },
  { label: i18n.t('network.text_4'), value: '10000' },
  { label: i18n.t('network.text_5'), value: '20000' },
  { label: '25G', value: '25000' },
  { label: '40G', value: '40000' },
  { label: '100G', value: '100000' },
]
